import { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PhotoUploader = ({ token, product, onChange }) => {
  const [uploading, setUploading] = useState(0);
  const [error, setError] = useState("");
  const photos = [product.image, ...(product.images || [])].filter(Boolean);
  const commit = (list) => onChange({ image: list[0] || "", images: list.slice(1) });

  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (!files.length) return;
    setError(""); setUploading(files.length);
    const added = [];
    for (const f of files) {
      const form = new FormData();
      form.append("file", f);
      try {
        const r = await axios.post(`${API}/admin/upload`, form, { headers: { "X-Admin-Token": token } });
        added.push(r.data.url);
      } catch (err) { setError(err?.response?.data?.detail || `Could not upload ${f.name}`); }
      setUploading(n => n - 1);
    }
    commit([...photos, ...added]);
  };

  return (
    <div className="field full-row" data-testid="product-form-photos">
      <span>Photos (first one is the main photo)</span>
      <div className="admin-photos">
        {photos.map((src, i) => (
          <div className="admin-photo" key={src + i} data-testid={`product-photo-${i}`}>
            <img src={src} alt="" />
            <button type="button" onClick={() => commit(photos.filter((_, j) => j !== i))} aria-label="Remove photo" data-testid={`product-photo-remove-${i}`}>×</button>
            {i === 0 ? <small>Main</small> : <small style={{ cursor: "pointer" }} onClick={() => commit([src, ...photos.filter((_, j) => j !== i)])} data-testid={`product-photo-main-${i}`}>Make main</small>}
          </div>
        ))}
        <label className="admin-upload-btn" data-testid="product-photo-upload-label">
          {uploading ? `Uploading ${uploading}…` : "+ Add photos"}
          <input type="file" accept="image/jpeg,image/png,image/webp,image/gif" multiple hidden onChange={upload} disabled={!!uploading} data-testid="product-photo-upload-input" />
        </label>
      </div>
      {error && <small className="eta-error" data-testid="product-photo-error">{error}</small>}
    </div>
  );
};
